<template>
  <div
    class="role--list"
    v-loading="loading"
    :element-loading-text="$t('lang.k_117001')"
    element-loading-background="rgba(255,255,255,.9)"
  >
    <!-- 全部无结果 -->
    <div class="all-no-data" v-if="roleDao && roleDao.total === 0 && role_name === ''">
      <null-page nullType="nullData" :text="$t('lang.k_117002')" :height="0">
        <vh-button type="primary" round v-preventReClick @click.prevent.stop="addRole">
          {{ $t('lang.k_117003') }}
        </vh-button>
      </null-page>
    </div>
    <!-- 全部有结果 -->
    <div class="all-yes-data" v-else>
      <!-- 搜索 -->
      <div class="role--list--search">
        <vh-button size="medium" type="primary" round @click.prevent.stop="addRole">
          {{ $t('lang.k_117003') }}
        </vh-button>
        <vh-button
          size="medium"
          round
          plain
          @click.prevent.stop="multiMsgDel"
          :disabled="!(this.checkRows && this.checkRows.length > 0)"
        >
          {{ $t('lang.k_117004') }}
        </vh-button>
        <vh-input
          :placeholder="$t('lang.k_117005')"
          v-model="role_name"
          clearable
          round
          v-clearEmoij
          @input="checkoutList"
          @clear="initQuerySonList"
          class="search-query"
          @keyup.enter.native="initQuerySonList"
        >
          <i class="vh-icon-search vh-input__icon" slot="prefix" @click="initQuerySonList"></i>
        </vh-input>
      </div>
      <!-- 有消息内容 -->
      <div>
        <!-- 表格与分页 -->
        <table-list
          ref="roleTab"
          :isHandle="true"
          :manageTableData="roleDao.list"
          :tabelColumnLabel="roleTableColumn"
          :totalNum="roleDao.total"
          :tableRowBtnFun="tableRowBtnFun"
          :needPagination="true"
          width="114px"
          max-height="auto"
          scene="roleList"
          :pageLimit="query.limit"
          @getTableList="getRoleList"
          @changeTableCheckbox="checkMoreRow"
          @onHandleBtnClick="onHandleBtnClick"
        ></table-list>
      </div>
      <!-- 无消息内容 -->
      <null-page
        class="search-no-data"
        :height="0"
        v-if="roleDao && roleDao.total === 0"
      ></null-page>
    </div>
    <!-- 添加子账号 -->
    <VhallDialog
      :width="$i18n.locale == 'en' ? '700px' : '600px'"
      :visible.sync="roleDialogVisible"
      :title="roleForm.executeType === 'edit' ? $t('lang.k_117006') : $t('lang.k_117003')"
      append-to-body
    >
      <vh-form
        :model="roleForm"
        ref="roleForm"
        class="createRole"
        :rules="roleFormRules"
        :label-width="$i18n.locale == 'en' ? '120px' : '80px'"
      >
        <vh-form-item :label="$t('lang.k_117007')" prop="role_name">
          <vh-input
            type="text"
            v-clearEmoij
            :placeholder="$t('lang.k_117008')"
            autocomplete="off"
            v-model="roleForm.role_name"
            :maxlength="15"
            show-word-limit
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_117009')" prop="remark" class="remark--item">
          <vh-input
            type="text"
            v-clearEmoij
            :placeholder="$t('lang.k_117010')"
            autocomplete="off"
            v-model="roleForm.remark"
            :maxlength="30"
            show-word-limit
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_117011')" prop="permission_webinar" class="switch--item">
          <div class="switch__box">
            <vh-checkbox
              v-model="roleForm.permission_webinar"
              :disabled="true"
              :true-label="1"
              :false-label="0"
            >
              {{ $t('lang.k_117012') }}
            </vh-checkbox>
            <vh-checkbox
              v-model="roleForm.permission_webinar_delete"
              :true-label="1"
              :false-label="0"
            >
              {{ $t('lang.k_117013') }}
            </vh-checkbox>
          </div>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_117014')" prop="permission_content" class="switch--item">
          <div class="switch__box">
            <vh-checkbox v-model="roleForm.permission_content" :true-label="1" :false-label="0">
              {{ $t('lang.k_117015') }}
            </vh-checkbox>
            <vh-checkbox
              v-model="roleForm.permission_content_download"
              :disabled="roleForm.permission_content == 0"
              :true-label="1"
              :false-label="0"
            >
              {{ $t('lang.k_117016') }}
            </vh-checkbox>
          </div>
        </vh-form-item>
        <vh-form-item
          :label="$t('lang.k_117017')"
          prop="permission_data"
          class="switch--item"
          v-if="permission?.view_report == 1"
        >
          <div class="switch__box">
            <div class="checkbox-warpper">
              <vh-checkbox v-model="roleForm.permission_data" :true-label="1" :false-label="0">
                {{ $t('lang.k_117018') }}
              </vh-checkbox>
            </div>
            <div class="checkbox-warpper">
              <vh-checkbox
                v-model="roleForm.permission_data_download"
                :disabled="roleForm.permission_data == 0"
                :true-label="1"
                :false-label="0"
              >
                {{ $t('lang.k_117019') }}
              </vh-checkbox>
              <div class="checkbox-warpper__help">
                <vh-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('lang.k_117020')"
                  placement="top"
                >
                  <i class="iconfont-v3 saasicon_help_m"></i>
                </vh-tooltip>
              </div>
            </div>
            <div class="checkbox-warpper" v-if="hasDownloadPdf">
              <vh-checkbox
                v-model="roleForm.permission_data_download_pdf"
                :disabled="roleForm.permission_data == 0"
                :true-label="1"
                :false-label="0"
              >
                {{ $t('lang.k_117021') }}
              </vh-checkbox>
              <div class="checkbox-warpper__help">
                <vh-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('lang.k_117022')"
                  placement="top"
                >
                  <i class="iconfont-v3 saasicon_help_m"></i>
                </vh-tooltip>
              </div>
            </div>
          </div>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_117023')" prop="permission_fin" class="switch--item">
          <div class="switch__box">
            <vh-checkbox v-model="roleForm.permission_fin" :true-label="1" :false-label="0">
              {{ $t('lang.k_117024') }}
            </vh-checkbox>
          </div>
        </vh-form-item>
        <vh-form-item
          v-if="hasDownloadPdf || hasConsoleLogo"
          :label="$t('lang.k_117025')"
          prop="permission_fin"
          class="switch--item"
        >
          <div class="switch__box" v-if="hasDownloadPdf">
            <vh-checkbox
              v-model="roleForm.permission_operating_watermark"
              :true-label="1"
              :false-label="0"
            >
              {{ $t('lang.k_117026') }}
            </vh-checkbox>
            <vh-checkbox
              v-model="roleForm.permission_operating_watermark_parent"
              :true-label="1"
              :false-label="0"
            >
              {{ $t('lang.k_117027') }}
            </vh-checkbox>
          </div>
          <div class="switch__box" v-if="hasConsoleLogo">
            <vh-checkbox
              v-model="roleForm.permission_setting_logo"
              :true-label="1"
              :false-label="0"
            >
              {{ $t('lang.k_117028') }}
            </vh-checkbox>
            <vh-checkbox
              v-model="roleForm.permission_setting_use_parent_logo"
              :true-label="1"
              :false-label="0"
            >
              {{ $t('lang.k_117029') }}
            </vh-checkbox>
          </div>
        </vh-form-item>
      </vh-form>
      <span slot="footer" class="dialog-footer">
        <vh-button type="info" @click="roleDialogVisible = false" size="medium" plain round>
          {{ $t('lang.k_117030') }}
        </vh-button>
        <vh-button type="primary" @click.prevent.stop="executeRoleSend" size="medium" round>
          {{ $t('lang.k_117031') }}
        </vh-button>
      </span>
    </VhallDialog>
    <!-- 添加子账号 -->
  </div>
</template>

<script>
  import NullPage from '../../PlatformModule/Error/nullPage.vue';
  import { sessionOrLocal } from '@/utils/utils';

  export default {
    name: 'roleList.vue',
    components: {
      NullPage
    },
    data() {
      return {
        loading: false,
        query: {
          pos: 0,
          limit: 10,
          pageNumber: 1
        },
        role_name: '',
        roleDao: {
          total: 0,
          list: []
        },
        isHandle: false, // 是否有操作项
        roleTableColumn: [
          {
            label: this.$t('lang.k_117007'),
            key: 'role_name',
            width: 'auto'
          },
          {
            label: this.$t('lang.k_117032'),
            key: 'child_count',
            width: 200
          },
          {
            label: this.$t('lang.k_117033'),
            key: 'remark',
            width: 200
          }
        ],
        tableRowBtnFun: [
          {
            name: this.$t('lang.k_117034'),
            methodName: 'roleEdit'
          },
          {
            name: this.$t('lang.k_117035'),
            methodName: 'roleDel'
          }
        ],
        ids: [],
        checkRows: [],
        roleDialogVisible: false,
        roleForm: {
          id: null,
          name: null,
          type: 'add',
          role_name: '',
          remark: '',
          permission_webinar: 1, // 直播管理开关 1开 0关闭
          permission_content: 1, // 回放管理开关 1开 0关闭
          permission_content_download: 1, // 回放管理下载回放开关 1开 0关闭
          permission_data: 1, // 数据管理 1开 0关闭
          permission_data_download: 1, // 数据管理下载可编辑数据 1开 0关闭
          permission_data_download_pdf: 1, // 数据管理下载 PDF 1开 0关闭
          permission_fin: 1, // 财务管理 1开 0关闭
          permission_operating_watermark: 1, // 下载文档水印 1开 0关闭
          permission_operating_watermark_parent: 0, // 使用主账号下载文档水印 1开 0关闭
          permission_setting_logo: 0, // 设置控制台logo
          permission_setting_use_parent_logo: 0, // 使用主账号控制台logo
          permission_webinar_delete: 1 // 直播管理删除直播开关 1开 0关闭
        },
        reRoleForm: {
          permission_webinar: 1, // 直播管理开关 1开 0关闭
          permission_content: 1, // 回放管理开关 1开 0关闭
          permission_content_download: 1, // 回放管理下载回放开关 1开 0关闭
          permission_data: 1, // 数据管理 1开 0关闭
          permission_data_download: 1, // 数据管理下载可编辑数据 1开 0关闭
          permission_data_download_pdf: 1, // 数据管理下载 PDF 1开 0关闭
          permission_fin: 1, // 财务管理 1开 0关闭
          permission_operating_watermark: 1, // 下载文档水印 1开 0关闭
          permission_operating_watermark_parent: 0, // 使用主账号下载文档水印 1开 0关闭
          permission_setting_logo: 0, // 设置控制台logo
          permission_setting_use_parent_logo: 0, // 使用主账号控制台logo
          permission_webinar_delete: 1 // 直播管理删除直播开关 1开 0关闭
        },
        roleFormRules: {
          role_name: [{ required: true, message: this.$t('lang.k_117008'), trigger: 'blur' }]
        },

        // 是否需要显示下载pdf相关的设置：影响数据管理→下载pdf数据、运营管理→下载文档水印、使用主账号下载文档水印
        hasDownloadPdf: false,
        // 是否有控制台标识权限： 影响运营管理→设置控制台logo、使用主账号控制台logo
        hasConsoleLogo: false
      };
    },
    computed: {
      permission() {
        return this.$store.state.permission;
      }
    },
    watch: {
      'roleForm.permission_content'(val) {
        if (val == 0) {
          this.roleForm.permission_content_download = 0;
        }
      },
      'roleForm.permission_data'(val) {
        if (val == 0) {
          this.roleForm.permission_data_download = 0;
          this.roleForm.permission_data_download_pdf = 0;
        }
      },
      'roleForm.permission_operating_watermark'(val) {
        if (val == 1) {
          this.roleForm.permission_operating_watermark_parent = 0;
        }
      },
      'roleForm.permission_operating_watermark_parent'(val) {
        if (val == 1) {
          this.roleForm.permission_operating_watermark = 0;
        }
      },
      'roleForm.permission_setting_logo'(val) {
        if (val == 1) {
          this.roleForm.permission_setting_use_parent_logo = 0;
        }
      },
      'roleForm.permission_setting_use_parent_logo'(val) {
        if (val == 1) {
          this.roleForm.permission_setting_logo = 0;
        }
      }
    },
    methods: {
      checkoutList(newValue) {
        if (!newValue) {
          this.initQuerySonList();
        }
      },
      // 表格操作列回调函数， val表示每行
      onHandleBtnClick(val) {
        let methodsCombin = this.$options.methods;
        methodsCombin[val.type](this, val);
      },
      // 批量选择
      checkMoreRow(val) {
        console.log('checkMoreRow', val);
        /*this.ids = val.map(item => {
        if (item.child_count > 0) {
          this.$vhAlert('当前角色已关联子账号，请先解绑关系后再进行删除', '提示', {
            confirmButtonText: '我知道了',
            lockScroll: false,
            customClass: 'zdy-alert-box'
          }).then(()=>{
          }).catch(()=>{});
        } else {
          return item.id;
        }
      });*/
        this.checkRows = val;
        console.log('结果复制', this.checkRows);
      },
      // 批量删除
      multiMsgDel() {
        if (!(this.checkRows && this.checkRows.length > 0)) {
          this.$vhMessage({
            message: `${this.$t('lang.k_117036')}`,
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        } else {
          // 判断是否存在有角色已关联子账号
          let isRoleInclude = this.checkRows.filter(item => {
            return item.child_count > 0;
          });
          if (isRoleInclude && isRoleInclude.length > 0) {
            this.$vhAlert(this.$t('lang.k_117037'), this.$t('lang.k_117038'), {
              confirmButtonText: this.$t('lang.k_117039'),
              customClass: 'zdy-alert-box',
              center: true,
              lockScroll: false
            })
              .then(() => {})
              .catch(() => {});
          } else {
            this.ids = this.checkRows.map(item => {
              return item.id;
            });
            this.deleteData(this.ids.join(','), 1);
          }
        }
      },
      deleteData(ids, index) {
        this.$vhConfirm(this.$t('lang.k_117040'), this.$t('lang.k_117038'), {
          confirmButtonText: this.$t('lang.k_117031'),
          cancelButtonText: this.$t('lang.k_117030'),
          customClass: 'zdy-message-box',
          lockScroll: false,
          roundButton: true,

          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            this.$fetch('sonRoleDel', {
              ids: ids
            })
              .then(res => {
                this.$vhall_paas_port({
                  k: index == 1 ? 100829 : 100828,
                  data: {
                    business_uid: this.$parent.userId,
                    user_id: '',
                    webinar_id: '',
                    refer: '',
                    s: '',
                    report_extra: {},
                    ref_url: '',
                    req_url: ''
                  }
                });
                this.$vhMessage({
                  message: `${this.$t('lang.k_117041')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                this.ids = [];
                this.checkRows = [];
                try {
                  this.$refs.roleTab.clearSelect();
                } catch (e) {
                  console.log(e);
                }
                this.initComp();
              })
              .catch(res => {
                console.log(res);
                this.$vhMessage({
                  message: res.msg || this.$t('lang.k_117042'),
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              });
          })
          .catch(() => {});
      },
      // 删除单条消息数据
      roleDel(that, { rows }) {
        if (rows.child_count > 0) {
          that
            .$vhAlert(that.$t('lang.k_117037'), that.$t('lang.k_117038'), {
              confirmButtonText: that.$t('lang.k_117039'),
              customClass: 'zdy-alert-box',
              center: true,
              lockScroll: false
            })
            .then(() => {})
            .catch(() => {});
        } else {
          that.deleteData(rows.id, 2);
        }
      },
      // 编辑子账号
      async roleEdit(that, { rows }) {
        that.roleDialogVisible = true;
        that.roleForm.executeType = 'edit';
        that
          .$fetch('sonRoleGet', {
            id: rows.id
          })
          .then(res => {
            if (res.data) {
              console.log('--roleEdit res.data:', res.data);
              that.roleForm = Object.assign(that.roleForm, res.data);

              that.reRoleForm.permission_webinar = res.data.permission_webinar;
              that.reRoleForm.permission_content = res.data.permission_content;
              that.reRoleForm.permission_content_download = res.data.permission_content_download;

              that.reRoleForm.permission_data = res.data.permission_data;
              that.reRoleForm.permission_data_download = res.data.permission_data_download;
              that.reRoleForm.permission_data_download_pdf = res.data.permission_data_download_pdf;
              that.reRoleForm.permission_fin = res.data.permission_fin;
              that.reRoleForm.permission_webinar_delete = res.data.permission_webinar_delete;

              /* prettier-ignore */
              that.reRoleForm.permission_operating_watermark = res.data.permission_operating_watermark;
              /* prettier-ignore */
              that.reRoleForm.permission_operating_watermark_parent = res.data.permission_operating_watermark_parent;

              that.reRoleForm.permission_setting_logo = res.data.permission_setting_logo;
              that.reRoleForm.permission_setting_use_parent_logo =
                res.data.permission_setting_use_parent_logo;
            }
          })
          .catch(res => {
            console.log(res);
            that.$vhMessage({
              message: res.msg || that.$t('lang.k_117043'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      // 创建子账号
      addRole() {
        this.roleDialogVisible = true;
        this.roleForm.executeType = 'add';
        this.roleForm.id = null;
        this.$nextTick(() => {
          this.$refs.roleForm.resetFields();
          // 开关重置
          this.roleForm.permission_content = 1; // 内容管理开关 1开 0关闭
          this.roleForm.permission_content_download = 1;

          this.roleForm.permission_data = 1; // 数据管理 1开 0关闭
          this.roleForm.permission_data_download = 1;
          this.roleForm.permission_data_download_pdf = 1;

          this.roleForm.permission_fin = 1; // 财务管理 1开 0关闭

          this.roleForm.permission_operating_watermark = 1;
          this.roleForm.permission_operating_watermark_parent = 0;

          this.roleForm.permission_setting_logo = 0;
          this.roleForm.permission_setting_use_parent_logo = 0;
          this.roleForm.permission_webinar_delete = 1; // 直播管理 1开 0关闭
        });
      },
      // 保存子账号信息新增 or 修改
      executeRoleSend() {
        this.$refs.roleForm.validate(valid => {
          if (valid) {
            const params = JSON.parse(JSON.stringify(this.roleForm));
            if (!this.hasDownloadPdf) {
              // 配置未开，下面几项不修改
              delete params.permission_data_download_pdf;
              delete params.permission_operating_watermark;
              delete params.permission_operating_watermark_parent;
            }
            if (!this.hasConsoleLogo) {
              // 配置未开，下面几项不修改
              delete params.permission_setting_logo;
              delete params.permission_setting_use_parent_logo;
            }
            console.log('params:', params);
            this.$fetch(this.roleForm.executeType === 'add' ? 'sonRoleAdd' : 'sonRoleEdit', params)
              .then(res => {
                this.setReportData();
                this.$vhMessage({
                  message: `${this.$t('lang.k_117044')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                this.roleDialogVisible = false;
                this.initComp();
              })
              .catch(res => {
                console.log(res);
                this.$vhMessage({
                  message: res.msg || this.$t('lang.k_117045'),
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              });
          }
        });
      },
      setReportData() {
        if (this.roleForm.executeType === 'add') {
          this.$vhall_paas_port({
            k: 100823,
            data: {
              business_uid: this.$parent.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhall_paas_port({
            k: this.roleForm.permission_content ? 100825 : 100824,
            data: {
              business_uid: this.$parent.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhall_paas_port({
            k: this.roleForm.permission_data ? 100827 : 100826,
            data: {
              business_uid: this.$parent.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        } else {
          if (this.roleForm.permission_content !== this.reRoleForm.permission_content) {
            this.$vhall_paas_port({
              k: this.roleForm.permission_content ? 100825 : 100824,
              data: {
                business_uid: this.$parent.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
          }
          if (this.roleForm.permission_data !== this.reRoleForm.permission_data) {
            this.$vhall_paas_port({
              k: this.roleForm.permission_data ? 100827 : 100826,
              data: {
                business_uid: this.$parent.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
          }
        }
      },
      // 获取列表数据
      getRoleList(row) {
        if (row) {
          this.query.pos = row.pos;
          this.query.pageNumber = row.pageNum;
          this.query.limit = row.limit;
        }
        this.loading = true;
        this.$fetch('sonRoleList', {
          role_name: this.role_name,
          pos: this.query.pos,
          limit: this.query.limit
        })
          .then(res => {
            this.loading = false;
            this.roleDao =
              res && res.code === 200 && res.data
                ? res.data
                : {
                    total: 0,
                    list: []
                  };
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
            this.roleDao = {
              total: 0,
              list: []
            };
          });
      },
      initComp() {
        this.initQuerySonList();
      },
      initQuerySonList() {
        this.query.pos = 0;
        this.query.pageNumber = 1;
        // this.query.limit = 10;
        if (this.role_name) {
          this.$vhall_paas_port({
            k: 100830,
            data: {
              business_uid: this.$parent.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
        // 表格切换到第一页
        try {
          this.$refs.roleTab && (this.$refs.roleTab.pageInfo.pageNum = 1);
          this.$refs.roleTab && (this.$refs.roleTab.pageInfo.pos = 0);
        } catch (e) {
          console.log(e);
        }
        this.getRoleList();
      }
    },
    created() {
      const SAAS_VS_PES = sessionOrLocal.get('SAAS_VS_PES', 'localStorage');
      const permissions = JSON.parse(SAAS_VS_PES || null);
      this.hasDownloadPdf = !!permissions?.['download_pdf'];
      this.hasConsoleLogo = !!permissions?.['ui.console_logo'];
    }
  };
</script>
<style lang="less" scoped>
  .role--list {
    min-height: 292px;
  }
  .all-no-data {
    /* 基于外边框已经有距离： padding: 24px 24px 40px 24px; */
    padding-top: 30px;
    margin-top: 164px;
    .createActive {
      padding-bottom: 30px;
    }
  }
  .all-yes-data {
    padding: 24px 24px 40px 24px;
  }
  .search-no-data {
    padding-top: 148px;
    ::v-deep .search {
      padding-bottom: 0;
    }
  }

  .role--list--search {
    margin-bottom: 20px;
    .vh-select {
      float: right;
      margin-right: 20px;
    }
    .search-query.vh-input {
      width: 220px;
      float: right;
    }
  }

  .checkbox-warpper {
    display: inline-block;
    margin-right: 24px;

    &__help {
      line-height: 40px;
      padding-left: 3px;
      display: inline-block;

      .saasicon_help_m {
        vertical-align: bottom;
      }
    }
  }
</style>
<style lang="less">
  .createRole {
    .leve3_title {
      margin-left: 5px;
    }
  }
</style>
